import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-additional',
  templateUrl: './additional.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: GeneralConsultAdditionalComponent, multi: true }
  ]
})
export class GeneralConsultAdditionalComponent extends BaseValueAccessor<string>{
  readonly screen = generalConsultDetailConstants.additionalInformation;
  @Input() turn = -1;
  @Input() readonly = false;
  expandSection = true;
}
